/***
 * Created on 2023/10/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";

function EmailSentComponent({qid}) {
    const { t } = useTranslation();
    const location = useLocation();

    const goToLogin = () => {
        window.location.href = window.location.href.replace('forget_password/success', 'signin');
    }

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Forgot Password@')}</div>
            <div className="common-page-body">
                <p>{t('@An email has been sent to@')} <span className="font-semibold pl-4 pr-4">{location?.state?.qid}</span></p>
                <p>{t('@Please check your email to reset your password.@')}</p>
            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={goToLogin}>{t('@Sign in now.@')}</button>
                </div>
            </div>
        </section>
    );
}

export default EmailSentComponent;